module.exports = __webpack_public_path__ + "img/artisco.518bf856.jpg";